import { Injector, Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {

  readonly configPath = './config/app-config.json';
  private appConfig: any;

  constructor(@Inject(Injector) private injector: Injector) {
  }

  async loadConfig(config?: any): Promise<void> {
    const httpClient = this.injector.get(HttpClient);

    if (config) {
      this.appConfig = config;
    } else {
      this.appConfig = await httpClient.get(this.configPath).toPromise();
    }

  }

  get config() {
    return this.appConfig;
  }
}
